@if (!config.hideSidebar) {
    <meta-sidebar [menuItems]="sidebarMenuItems" [userMenuItems]="sidebarUserMenuItems" [activeItem]="activeItem$ | async"
        [hideUserMenu]="config.hideUserMenu || false" (statusChanged)="sideBarShown$.next($event)"
        (menuItemClicked)="handleMenuItemClicked($event.id)" (userMenuItemClicked)="handleUserMenuItemClicked($event.id)" />
}

<main id="mainContent" class="bg-body flex flex-col flex-1 transition-all duration-300 pb-6 min-h-screen"
    [ngClass]="{'xl:pl-sidebar': sideBarShown$ | async}">
    <section class="pt-6 pb-3 bg-body px-base xl:px-base-desk mb-3 h-full">
        <meta-calendar [desktopLabel]="config.globalDesktopLabel" [mobileLabel]="config.globalMobileLabel" [toolbarSetup]="config.globalToolbarConfig"></meta-calendar>
    </section>

    <meta-footer [hideMetaCredits]="hideMetaCredits" [hideCustomFooter]="hideFooter" />
</main>